import styled from 'styled-components';

export const SelectPlanStyles = styled.section`
  margin: 24px auto;
  padding: 0 16px;
  max-width: 540px;
`;

export const SelectPlanListStyles = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

export const SubscriptionButtonStyles = styled.button`
  display: block;
  border-radius: 12px;
  border: 1px solid #8f5af7;
  background: linear-gradient(180deg, #a77aff 0%, #6d2ceb 100%);
  padding: 11px 60px;
  color: #fff;
  margin: 16px auto 16px;
  width: 100%;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
`;

export const SpinnerContainerStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;

  .white-spinner {
    color: white;
  }
`;
